/* eslint-disable react-refresh/only-export-components -- exports helper toast function with component */
import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;
type ResolvedTheme = Exclude<ToasterProps["theme"], undefined>;

const Toaster = ({ ...props }: ToasterProps) => {
	const { theme } = useTheme();
	const resolvedTheme: ResolvedTheme = (theme ?? "system") as ResolvedTheme;

	return (
		<Sonner
			theme={resolvedTheme}
			className="toaster group"
			toastOptions={{
				classNames: {
					toast:
						"group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
					description: "group-[.toast]:text-muted-foreground",
					actionButton:
						"group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
					cancelButton:
						"group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
				},
			}}
			{...props}
		/>
	);
};

export { Toaster, toast };
